import React from 'react';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { AuthProvider } from './features/auth/context/AuthContext';
import { CourseProvider } from './features/courseGen/context/CourseContext';
import AppRouter from './router/AppRouter';

function App() {
  return (
    <MantineProvider
      theme={{
        colorScheme: 'light',
        primaryColor: 'indigo',
        colors: {
          brand: ['#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#42A5F5', '#2196F3', '#1E88E5', '#1976D2', '#1565C0', '#0D47A1'],
          accent: ['#F3E5F5', '#E1BEE7', '#CE93D8', '#BA68C8', '#AB47BC', '#9C27B0', '#8E24AA', '#7B1FA2', '#6A1B9A', '#4A148C'],
        },
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
        headings: {
          fontFamily: 'Poppins, sans-serif',
          sizes: {
            h1: { fontSize: '2.5rem', lineHeight: 1.4 },
            h2: { fontSize: '2rem', lineHeight: 1.4 },
            h3: { fontSize: '1.5rem', lineHeight: 1.4 },
            h4: { fontSize: '1.25rem', lineHeight: 1.4 },
          },
        },
        components: {
          Button: {
            defaultProps: {
              radius: 'md',
            },
            styles: (theme) => ({
              root: {
                fontWeight: 600,
                transition: 'transform 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                },
              },
            }),
          },
          Paper: {
            defaultProps: {
              radius: 'md',
              p: 'xl',
            },
            styles: (theme) => ({
              root: {
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                transition: 'box-shadow 0.2s ease',
                '&:hover': {
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                },
              },
            }),
          },
          Title: {
            styles: (theme) => ({
              root: {
                color: theme.colors.indigo[9],
              },
            }),
          },
        },
        breakpoints: {
          xs: '30em',    // 480px
          sm: '48em',    // 768px
          md: '64em',    // 1024px
          lg: '74em',    // 1184px
          xl: '90em',    // 1440px
        },
      }}
      withGlobalStyles
      withNormalizeCSS
    >
      <Notifications position="top-right" />
      <AuthProvider>
        <CourseProvider>
          <AppRouter />
        </CourseProvider>
      </AuthProvider>
    </MantineProvider>
  );
}

export default App; 